import React from "react";
import PageBuilder from "../../components/PageBuilder/PageBuilder";
import { useSanityContent } from "../../hooks/useSanityContent";
import { PAGE_QUERY } from "../../sanity/queries";

const fallbackSections = [
  {
    _type: "heroAlternative",
    title: "Agribusiness",
    description: "In line with our project and property management skills we provide support to local farms with the production and processing of agricultural products mainly Rubber and Oil Palm.",
    image: "/pexels-cottonbro-7439134.jpg",
    buttonText: "Get a Free Consultation",
    buttonLink: "/contact",
  },
  {
    _type: "alternatingImageText",
    sections: [
      {
        title: "Plantation Establishment",
        bullets: [
          "Land preparation and clearing for rubber and oil palm plantations",
          "Nursery establishment and management (rubber seedlings and oil palm sprouts)",
          "Planting and field layout according to recommended spacing",
          "Soil testing and site suitability assessments",
        ],
        image: "/plantation.jpeg",
        imageAlt: "Project audit analysis and reporting",
      },
      {
        title: "Crop Management and Maintenance",
        bullets: [
          "Tapping system management and latex harvesting",
          "Tree health monitoring and disease control/three farming system",
          "Application of fertilisers and soil amendments",
          "Weed management and pruning",
          "Latex collection, coagulation, and primary handling Oil Palm",
          "Timely harvesting of ripe Fresh Fruit Bunches",
          "Quality control to minimise free fatty acid (FFA) levels",
          "Transport of FFBs to processing mills",
        ],
        image: "/plantationNew.jpeg",
        imageAlt: "Team collaboration and change management workshop",
      },
    ],
  },
  { _type: "contactSection" },
];

export default function AgriBusiness() {
  const { data } = useSanityContent(PAGE_QUERY("agribusiness"), { sections: fallbackSections });
  return <PageBuilder sections={data.sections} />;
}
